module.exports = __webpack_public_path__ + "img/warning.979cb280.svg";